import { toast } from "react-toastify";
import * as actionType from "../../../context/actions";

/**
 * Add or update item data in local storage using context state and dispatch
 */
const AddItemDataInLocal = async (state, dispatch, itemData) => {
    try {
        if (!Array.isArray(itemData)) return;

        const existingItems = itemData || [];
        const updatedItems = [...existingItems];

        for (const newItem of itemData) {
            const existingIndex = existingItems.findIndex(
                (item) =>
                    item.name?.toLowerCase() === newItem.name?.toLowerCase()
            );

            if (existingIndex !== -1) {
                // ✅ Update existing item
                updatedItems[existingIndex] = {
                    ...existingItems[existingIndex],
                    defaultPrice: newItem.price?.toString() || existingItems[existingIndex].defaultPrice?.toString(),
                    subtitle: newItem.subtitle?.toString() || existingItems[existingIndex].subtitle?.toString(),
                    updatedDate: Date.now().toString(),
                };
            } else {
                // ✅ Add new item
                const cleanedItem = {
                    createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                    createdById: state?.USERID || null,
                    updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                    updatedById: state?.USERID || null,
                    itemId: newItem.itemId?.toString() || Date.now().toString(),
                    name: newItem.name?.toString() || "",
                    defaultPrice: newItem.price?.toString() || "0.00",
                    purchasePrice: "0.00",
                    subtitle: newItem.subtitle?.toString() || "",
                    createdDate: Date.now().toString(),
                    updatedDate: Date.now().toString(),
                };
                updatedItems.push(cleanedItem);
            }
        }

        // ✅ Dispatch updated list
        dispatch({
            type: actionType.ITEMS,
            payload: updatedItems,
        });
        localStorage.setItem("LOCAL_ITEM", JSON.stringify(updatedItems));

    } catch (error) {
        console.error("❌ Error adding items locally:", error);
        toast.error("Failed to add/update items locally.");
    }
};

export default AddItemDataInLocal;
